import { stringToSlug } from '../../helpers/slug';

const centreSlug = context => {
  var _context$centre$slug, _context$centre;

  return (_context$centre$slug = (_context$centre = context.centre) === null || _context$centre === void 0 ? void 0 : _context$centre.slug) !== null && _context$centre$slug !== void 0 ? _context$centre$slug : '';
};

const getUrlForNationalStorefront = hit => "/store/".concat(hit.retailerId, "/").concat(hit.slug);

const getUrlForStore = (hit, context) => "/".concat(centreSlug(context), "/store/").concat(hit.objectID, "/").concat(hit.slug);

const getUrlForSite = (hit, context) => (hit.href || '').replace('CENTRE', centreSlug(context));

const getUrlForService = (hit, context) => "/".concat(centreSlug(context), "/service/").concat(hit.objectID, "/").concat(hit.slug);

const getUrlForLocalOffer = (hit, context) => "/".concat(centreSlug(context), "/offer/").concat(hit.objectID, "/").concat(hit.slug);

const getUrlForNationallOffer = (hit, _context) => "/offer/".concat(hit.objectID, "/").concat(hit.slug);

const getUrlForEvent = (hit, context) => "/".concat(centreSlug(context), "/event/").concat(hit.objectID, "/").concat(hit.slug);

const getUrlForNews = (hit, context) => "/".concat(centreSlug(context), "/news/").concat(hit.objectID, "/").concat(hit.slug);

const getUrlForLocalStory = (hit, context) => "/".concat(centreSlug(context), "/story/").concat(hit.objectID, "/").concat(hit.slug);

const getUrlForNationalStory = (hit, _context) => "/story/".concat(hit.objectID, "/").concat(hit.slug);

const getUrlForCentre = (hit, _context) => hit.href;

const getUrlForOnlineService = (hit, _context) => hit.href;

const getUrlForOtherStore = (hit, _context) => "/".concat(hit.centreSlug, "/store/").concat(hit.objectID, "/").concat(hit.slug);

const getUrlForProductCollection = (hit, _context) => "/shop/collection/".concat(hit.slug);

const getUrlForContentfulBrand = (hit, _context) => {
  var _hit$brandLinkUrl;

  return (_hit$brandLinkUrl = hit.brandLinkUrl) !== null && _hit$brandLinkUrl !== void 0 ? _hit$brandLinkUrl : "/shop/brand/".concat(hit.slug);
};

const getUrlForFacetBrand = (hit, _context) => "/shop/brand/".concat(hit.slug);

const getUrlForProduct = (hit, _context) => {
  const {
    brand,
    name,
    shop,
    variantGroupCode
  } = hit;
  const productSlug = brand ? stringToSlug("".concat(brand, "-").concat(name)) : stringToSlug(name);
  return "/shop/product/".concat(shop.id, "/").concat(variantGroupCode, "/").concat(productSlug);
};

const getUrlForWestfieldProduct = (hit, context) => "".concat(hit.href).concat(hit.objectID === 'physical-gift-card' ? "?wd=".concat(context.mkpCartCount > 0 ? 1 : 0) : '');

const getUrlForSearchSuggestion = (hit, context) => {
  var _hit$url;

  return ((_hit$url = hit.url) !== null && _hit$url !== void 0 ? _hit$url : '').replace('CENTRE', centreSlug(context));
};

const getUrlForProductQuerySuggestion = (hit, _context) => {
  const base = "/shop/products";
  const cat = hit.productsCategory.slug ? "/".concat(hit.productsCategory.slug) : '';
  const query = "?q=".concat(hit.query);
  return "".concat(base).concat(cat).concat(query);
};

export default function getUrlForHit(hit, context) {
  switch (hit.segment) {
    case 'nationalStorefronts':
      return getUrlForNationalStorefront(hit, context);

    case 'stores':
      return getUrlForStore(hit, context);

    case 'sites':
      return getUrlForSite(hit, context);

    case 'services':
      return getUrlForService(hit, context);

    case 'localOffers':
      return getUrlForLocalOffer(hit, context);

    case 'nationalOffers':
      return getUrlForNationallOffer(hit, context);

    case 'events':
      return getUrlForEvent(hit, context);

    case 'news':
      return getUrlForNews(hit, context);

    case 'localStories':
      return getUrlForLocalStory(hit, context);

    case 'nationalStories':
      return getUrlForNationalStory(hit, context);

    case 'centres':
      return getUrlForCentre(hit, context);

    case 'onlineServices':
      return getUrlForOnlineService(hit, context);

    case 'otherStores':
      return getUrlForOtherStore(hit, context);

    case 'products':
      return getUrlForProduct(hit, context);

    case 'westfieldProducts':
      return getUrlForWestfieldProduct(hit, context);

    case 'productCollections':
      return getUrlForProductCollection(hit, context);

    case 'contentfulBrands':
      return getUrlForContentfulBrand(hit, context);

    case 'facetBrands':
      return getUrlForFacetBrand(hit, context);

    case 'searchSuggestions':
      return getUrlForSearchSuggestion(hit, context);

    case 'productQuerySuggestions':
      return getUrlForProductQuerySuggestion(hit, context);

    default:
      throw new Error("Unknown segment ".concat(hit.segment));
  }
}